// Install before Router subscribes to hash changes. A panel-mounted listener runs
// too late: the router can unmount the panel during the same event dispatch.
let activeGuard = null;
let approvedURL = typeof window === 'undefined' ? '' : window.location.href;
let navigationSequence = 0;

async function guardNavigation(event) {
  const destination = window.location.href;
  if (!activeGuard?.isDirty()) { approvedURL = destination; return; }
  event.stopImmediatePropagation();
  const sequence = ++navigationSequence;
  const guard = activeGuard;
  window.history.replaceState(window.history.state, '', approvedURL);
  if (await guard.flush() && sequence === navigationSequence && guard === activeGuard) {
    window.location.href = destination;
  }
}

if (typeof window !== 'undefined') window.addEventListener('hashchange', guardNavigation, true);

export function registerPersonalNotesNavigationGuard(guard) {
  activeGuard = guard;
  approvedURL = window.location.href;
  return () => { if (activeGuard === guard) { activeGuard = null; navigationSequence++; } };
}
